import(/* webpackMode: "eager" */ "/vercel/path0/app/(marketing)/featured/page.tsx");
